import {createContext} from 'react'

const ZelleContext = createContext();

export default ZelleContext;
